import { gql } from '@apollo/client'

export const ACTIVATE_ACCOUNT_MUTATION = gql`
  mutation($input: ActivateAccountInput!) {
    activateAccount(input: $input)
  }
`
